import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import ScrollToTop from '@/components/ScrollToTop';
import MemberLayout from '@/components/MemberLayout';
import HomePage from '@/pages/HomePage';
import ProductPage from '@/pages/ProductPage';
import PricingPage from '@/pages/PricingPage';
import FAQPage from '@/pages/FAQPage';
import GrantToolPage from '@/pages/GrantToolPage';
import GrantVaultPage from '@/pages/GrantVaultPage';
import GrantsPage from '@/pages/GrantsPage';
import SuccessPage from '@/pages/SuccessPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import PrivacyPage from '@/pages/PrivacyPage';
import TermsPage from '@/pages/TermsPage';
import SignUpPage from '@/pages/SignUpPage';
import LoginPage from '@/pages/LoginPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import DashboardPage from '@/pages/DashboardPage';
import SetupWizardPage from '@/pages/SetupWizardPage';
import PublicProfilePage from '@/pages/PublicProfilePage';
import AdminDashboardPage from '@/pages/AdminDashboardPage';
import BillingPage from '@/pages/BillingPage';
import SupportAccessPage from '@/pages/SupportAccessPage';
import HelpCentrePage from '@/pages/HelpCentrePage';
import ImportPage from '@/pages/ImportPage';
import CompliancePage from '@/pages/CompliancePage';
import ClimateRisksPage from '@/pages/ClimateRisksPage';
import MaterialityPage from '@/pages/MaterialityPage';
import GovernancePage from '@/pages/GovernancePage';
import SocialMetricsPage from '@/pages/SocialMetricsPage';
import ScenarioStressTestPage from '@/pages/ScenarioStressTestPage';
import IdeasPage from '@/pages/IdeasPage';
import TeamPage from '@/pages/TeamPage';
import EntriesPage from '@/pages/EntriesPage';
import OffsetsPage from '@/pages/OffsetsPage';
import ActivityLogPage from '@/pages/ActivityLogPage';
import ReportsPage from '@/pages/ReportsPage';
import ReportBuilderPage from '@/pages/ReportBuilderPage';
import DataExportPage from '@/pages/DataExportPage';
import OrganisationProfilePage from '@/pages/OrganisationProfilePage';
import MessagesPage from '@/pages/MessagesPage';
import MyAccountPage from '@/pages/MyAccountPage';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Routes>
            {/* Public routes with navigation */}
            <Route path="/" element={<><Navigation /><HomePage /><Footer /></>} />
            <Route path="/product" element={<><Navigation /><ProductPage /><Footer /></>} />
            <Route path="/pricing" element={<><Navigation /><PricingPage /><Footer /></>} />
            <Route path="/faq" element={<><Navigation /><FAQPage /><Footer /></>} />
            <Route path="/grant-tool" element={<><Navigation /><GrantToolPage /><Footer /></>} />
            <Route path="/success" element={<><Navigation /><SuccessPage /><Footer /></>} />
            <Route path="/about" element={<><Navigation /><AboutPage /><Footer /></>} />
            <Route path="/contact" element={<><Navigation /><ContactPage /><Footer /></>} />
            <Route path="/privacy" element={<><Navigation /><PrivacyPage /><Footer /></>} />
            <Route path="/terms" element={<><Navigation /><TermsPage /><Footer /></>} />
            
            {/* Public Profile (no navigation - standalone) */}
            <Route path="/profile/:slug" element={<PublicProfilePage />} />
            
            {/* Auth routes (no navigation) */}
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            
            {/* Protected routes with MemberLayout (consistent header & tabs) */}
            <Route element={<ProtectedRoute><MemberLayout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/entries" element={<EntriesPage />} />
              <Route path="/offsets" element={<OffsetsPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/grants" element={<GrantsPage />} />
              <Route path="/compliance" element={<CompliancePage />} />
              <Route path="/risks" element={<ClimateRisksPage />} />
              <Route path="/materiality" element={<MaterialityPage />} />
              <Route path="/governance" element={<GovernancePage />} />
              <Route path="/social-metrics" element={<SocialMetricsPage />} />
              <Route path="/stress-test" element={<ScenarioStressTestPage />} />
              <Route path="/help" element={<HelpCentrePage />} />
              <Route path="/ideas" element={<IdeasPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/billing" element={<BillingPage />} />
              <Route path="/activity-log" element={<ActivityLogPage />} />
              <Route path="/data-export" element={<DataExportPage />} />
              <Route path="/profile" element={<OrganisationProfilePage />} />
              <Route path="/messages" element={<MessagesPage />} />
              <Route path="/my-account" element={<MyAccountPage />} />
            </Route>
            
            {/* Protected routes WITHOUT MemberLayout (special pages) */}
            <Route path="/setup" element={<ProtectedRoute><SetupWizardPage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboardPage /></ProtectedRoute>} />
            <Route path="/report-builder" element={<ProtectedRoute><ReportBuilderPage /></ProtectedRoute>} />
            <Route path="/dashboard/import" element={<ProtectedRoute><ImportPage /></ProtectedRoute>} />
            <Route path="/support/:action/:token" element={<ProtectedRoute><SupportAccessPage /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;